/**
 * indexSignifyProductPrices
 *
 * Rewrites a product price-and-availability response so `price.prices` — an
 * array Signify keys by nothing — becomes an object keyed by
 * `priceTypeIdentifier`, each whole entry kept, so both
 * `price.prices.CUSTOMER_PRICE.value` and `.formattedValue` are plain paths for
 * `resolveSignifyFieldValues`. Consumers: every field-mapping resolution of
 * this response. The response is copied shallowly, never mutated. An absent or
 * non-array `prices` becomes `{}`; an absent or `null` `price` is copied
 * through as-is, because the resolver's path reader yields `undefined` for any
 * segment it cannot index. Duplicate identifiers keep the LAST occurrence,
 * matching the object spread the array folds into.
 */

import type { ProductAndPriceAndAvailabilityResponse, SignifyPrice } from '../SignifyApi.types';

export const indexSignifyProductPrices = (
  response: ProductAndPriceAndAvailabilityResponse,
): Record<string, unknown> => {
  const { price } = response;
  if (!price) {
    return { ...response };
  }
  const prices: readonly SignifyPrice[] = Array.isArray(price.prices) ? price.prices : [];
  return {
    ...response,
    price: {
      ...price,
      prices: Object.fromEntries(prices.map((entry) => [entry.priceTypeIdentifier, entry])),
    },
  };
};
